<template>
	<AssessmentCharacteristics class="influence-characteristics"
		:is-skeleton="isSkeleton"
		:high-type="highType"
		:characteristics="characteristics"
	>
		<template #icon>
			<FontAwesomeIcon
				:icon="[ `far`, `bolt-lightning` ]"
			/>
		</template>
		<template #heading>{{ $t( "common.InfluenceCharacteristics__heading" ) }}</template>
	</AssessmentCharacteristics>
</template>

<script>
import CommonCharacteristics from "./CommonCharacteristicsProps";
import AssessmentCharacteristics from "./AssessmentCharacteristics";
export default {
	name: "InfluenceCharacteristics",
	mixins: [ CommonCharacteristics, ],
	components: {
		AssessmentCharacteristics,
	},
	computed: {
		characteristics() {
			const influence = this.assessment?.teamingContent?.influence || "";
			return influence
				.split( "," )
				.map( x => x.trim() )
				.filter( x => !!x );
		},
	},
};
</script>

<style lang="scss" scoped></style>
